import './index.css'
import * as React from 'react'
import { Box, Popover, Theme } from 'components/ds'
import { SwitcherPopoverTrigger } from './switcher-popover-trigger'
import { SwitcherPopoverContent } from './switcher-popover-content'
import styles from './index.module.css'

export function SwitcherPopover() {
  return (
    <Theme
      appearance="light"
      hasBackground={false}
      className={styles['switcher-popover-theme']}
    >
      <Popover.Root>
        <Popover.Trigger data-testid="business-switcher">
          <Box width="100%">
            <SwitcherPopoverTrigger />
          </Box>
        </Popover.Trigger>

        <Popover.Content
          width="290px"
          className={styles['switcher-popover-content']}
        >
          <SwitcherPopoverContent />
        </Popover.Content>
      </Popover.Root>
    </Theme>
  )
}
